/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SearchRequestSort } from './SearchRequestSort';
import {
    SearchRequestSortFromJSON,
    SearchRequestSortFromJSONTyped,
    SearchRequestSortToJSON,
    SearchRequestSortToJSONTyped,
} from './SearchRequestSort';

/**
 * 
 * @export
 * @interface SearchRequest
 */
export interface SearchRequest  {
    /**
     * 
     * @type {string}
     * @memberof SearchRequest
     */
    q?: string;
    /**
     * 
     * @type {SearchRequestSort}
     * @memberof SearchRequest
     */
    sort?: SearchRequestSort;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRequest
     */
    fq?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SearchRequest
     */
    foffset?: { [key: string]: number; };
    /**
     * 
     * @type {Array<SearchRequestOnlyEnum>}
     * @memberof SearchRequest
     */
    only?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SearchRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchRequest
     */
    limit?: number;
}


/**
 * @export
 */
export const SearchRequestOnlyEnum = {
    Results: 'results',
    Facets: 'facets'
} as const;
export type SearchRequestOnlyEnum = typeof SearchRequestOnlyEnum[keyof typeof SearchRequestOnlyEnum];


/**
 * Check if a given object implements the SearchRequest interface.
 */
export function instanceOfSearchRequest(value: object): value is SearchRequest {
    return true;
}

export function SearchRequestFromJSON(json: any): SearchRequest {
    return SearchRequestFromJSONTyped(json, false);
}

export function SearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
                  'q': json['q'] == null ? undefined : json['q'],
                  'sort': json['sort'] == null ? undefined : SearchRequestSortFromJSON(json['sort']),
              'fq': json['fq'] == null ? undefined : json['fq'],
                  'foffset': json['foffset'] == null ? undefined : json['foffset'],
              'only': json['only'] == null ? undefined : json['only'],
                  'offset': json['offset'] == null ? undefined : json['offset'],
                  'limit': json['limit'] == null ? undefined : json['limit'],
    };
}

export function SearchRequestToJSON(json: any): SearchRequest {
    return SearchRequestToJSONTyped(json, false);
}

export function SearchRequestToJSONTyped(value?: SearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'q': value['q'],
        'sort': SearchRequestSortToJSON(value['sort']),
        'fq': value['fq'] == null? value['fq']: value['fq'],
        'foffset': value['foffset'],
        'only': value['only'] == null? value['only']: value['only'],
        'offset': value['offset'],
        'limit': value['limit'],
    };
}


